import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import {
  selectManagers,
  fetchManagers,
} from '../../../reducers/Organisation/organisationManagersReducer'
import Avatar from '../../../Avatar'
import { getAssetLink } from '../../../helpers/get-asset-link'
import CollectionItem from '../../Collection/CollectionItem'
import CollectionList from '../../Collection/CollectionList'

export class OrganisationManagersList extends Component {
  static propTypes = {
    managers: PropTypes.array.isRequired,
    fetchManagers: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.fetchManagers()
  }

  render() {
    const { managers } = this.props
    return (
      <CollectionList>
        {typeof managers !== 'undefined' &&
          managers.map((manager) => {
            return (
              <Link key={manager.id} to={`/dashboard/organisation/managers/legacy/${manager.id}`}>
                <CollectionItem rounded mark>
                  <Avatar size="big">
                    <img
                      src={getAssetLink({
                        path: 'chitown-avatar/avatar',
                        file: manager.user.avatar,
                      })}
                      alt={''}
                    />
                  </Avatar>
                  <strong>
                    {manager.user.firstName} {manager.user.lastName}
                  </strong>
                  <span>{manager.user.email}</span>
                </CollectionItem>
              </Link>
            )
          })}
      </CollectionList>
    )
  }
}

export default connect((state) => ({ managers: selectManagers(state) }), { fetchManagers })(
  OrganisationManagersList,
)
